import PageWrapper from '../components/PageWrapper';
import LegalDocLayout from '../components/marketing/LegalDocLayout';

const sections = [
  {
    id: 'agreement',
    title: 'Agreement to Terms',
    content: [
      'By using Stavyn you agree to these Terms. We may update them at any time; continued use means you accept the updated Terms.',
    ],
  },
  {
    id: 'use-of-service',
    title: 'Use of Service',
    content: [
      'Use Stavyn only for lawful purposes. Do not reverse engineer, scrape, or misuse the platform. Use flight risk insights in compliance with applicable employment laws.',
    ],
  },
  {
    id: 'account-responsibilities',
    title: 'Account Responsibilities',
    content: [
      'You are responsible for your account and for ensuring your use complies with applicable privacy and employment laws.',
    ],
  },
  {
    id: 'intellectual-property',
    title: 'Intellectual Property',
    content: [
      'Stavyn owns the platform and its IP. You keep ownership of your data; we process it only to provide the service. We may use aggregated, anonymized data to improve our services.',
    ],
  },
  {
    id: 'data-usage',
    title: 'Data Usage',
    content: [
      'You must have a proper legal basis before submitting employee data. We process it as a data processor. Data is deleted within 90 days after termination, subject to legal retention.',
    ],
  },
  {
    id: 'limitation-of-liability',
    title: 'Limitation of Liability',
    content: [
      'Our insights are analytical tools, not legal or HR advice. To the maximum extent permitted by law, we are not liable for indirect or consequential damages.',
    ],
  },
  {
    id: 'termination',
    title: 'Termination',
    content: [
      'Either party may terminate at any time. We may suspend or terminate access for breach, non-payment, or harmful conduct. Surviving provisions (e.g. IP, liability, governing law) remain in effect.',
    ],
  },
  {
    id: 'governing-law',
    title: 'Governing Law',
    content: [
      'These Terms are governed by applicable law. Disputes may be resolved in a court of competent jurisdiction. If any provision is unenforceable, the rest remains in effect.',
    ],
  },
  {
    id: 'contact',
    title: 'Contact',
    content: [
      'Questions? Contact us at hello@stavyn.com.',
    ],
  },
];

export default function TermsPage() {
  return (
    <PageWrapper>
      <LegalDocLayout
        title="Terms of Service"
        lastUpdated="March 1, 2026"
        sections={sections}
        crossLinkTo="/privacy"
        crossLinkLabel="Privacy Policy"
      />
    </PageWrapper>
  );
}
